var app = angular.module("storefrontApp");
app.controller("homepageController", [
    "$interval",
    "$rootScope",
    "storageFactory",
    "$scope",
    "$window",
    "homepageElasticService",
    "randomService",
    "homepageService",
    "urlService",
    "configs",
    "commonService",
    "membershipService",
    "digitalEventFormatterService",
    function (
        $interval,
        $rootScope,
        storageFactory,
        $scope,
        $window,
        elasticService,
        randomService,
        homepageService,
        urlService,
        configs,
        commonService,
        membershipService,
        digitalEventFormatterService
    ) {
        // Controller properties
        $scope.activeMainAdIndex = 0;
        $scope.currentMainAd = null;

        // Clean up interval on scope destruction
        $scope.$on('$destroy', function () {
            if ($scope.carousalInterval) {
                $interval.cancel($scope.carousalInterval);
            }
        });

        // Helper function to convert image URL to WebP format
        function getWebpImgUrl(imgUrl) {
            if (angular.isDefined(imgUrl) && imgUrl && imgUrl.length > 0) {
                return imgUrl.substr(0, imgUrl.lastIndexOf(".")) + ".webp";
            }
            return null;
        }

        function updateCurrentMainAd() {
            if ($scope.mainAds && $scope.mainAds.length > 0) {
                $scope.currentMainAd = $scope.mainAds[$scope.activeMainAdIndex];
            }
        }

        // Fetch ads data
        $scope.getAdsData = function () {
            $scope.carousalImgLoaded = false;

            // Main carousel ads
            var mainAds = homepageService.getContent(storageFactory.get("carousalAds"));
            if (mainAds == null || $scope.resetCache) {
                getMainAds();
            } else {
                mainAds = JSON.parse(mainAds);
                if (angular.isUndefined(mainAds[0]) || angular.isUndefined(mainAds[0].webpImageURL)) {
                    getMainAds();
                }
                if (mainAds.length > 0) {
                    $scope.mainAds = angular.copy(mainAds);
                    updateCurrentMainAd();
                }
            }

            // Bottom ads
            var bottomAd_data = homepageService.getContent(storageFactory.get("bottomAds"));
            if (bottomAd_data == null || window.resetAdsCacheState) {
                getBottomAds();
            } else {
                $scope.bottomAds = JSON.parse(bottomAd_data);
            }

            // Sub ads
            var subAds_data = homepageService.getContent(storageFactory.get("subAds"));
            if (subAds_data == null || window.resetAdsCacheState) {
                getSubAdsData();
            } else {
                $scope.ads_data = JSON.parse(subAds_data);
                if ($scope.ads_data && $scope.ads_data.length > 0) {
                    $scope.activeAdId = $scope.ads_data[0].adId;
                }
            }

            // Homepage content
            try {
                var homepage_content = JSON.parse(homepageService.getContent(storageFactory.get("homeAds")));
                if (homepage_content == null || window.resetAdsCacheState) {
                    getHomePageContent();
                } else {
                    $scope.topCategoryAds = homepage_content.topCategoryAds;
                    $scope.bottomCategoryAds = homepage_content.bottomCategoryAds;
                    $scope.pictureAds = homepage_content.pictureAds;
                    if ($scope.pictureAds && $scope.pictureAds.length > 0) {
                        $scope.pictureAds.forEach(function (ad) {
                            ad.webpImageURL = getWebpImgUrl(ad.imageUrl);
                        });
                    }
                    $scope.carousalRightAds = homepage_content.carousalRightAds;
                }
            } catch (e) {
                getHomePageContent();
            }
        };

        //#region Main Ads
        function getMainAds() {
            homepageService.getCarousalAds().then(
                function (response) {
                    if (response && response.data && response.data.length > 0) {
                        var mainAds = response.data;
                        mainAds.forEach(function (ad) {
                            if (ad.imageURL) {
                                ad.webpImageURL = getWebpImgUrl(ad.imageURL.toLowerCase());
                            }
                        });

                        $scope.mainAds = angular.copy(mainAds);
                        updateCurrentMainAd();
                        if ($scope.mainAds.length > 0) {
                            storageFactory.set("carousalAds", JSON.stringify($scope.mainAds), true);
                        }
                    }
                }
            );
        }

        // Carousal Timer Function
        $scope.carousalTimerFn = function () {
            $scope.onCarousalNavClick(1);
        };

        // Handle carousal navigation
        $scope.onCarousalNavClick = function (val) {
            if ($scope.carousalInterval) {
                $interval.cancel($scope.carousalInterval);
            }

            if ($scope.mainAds && $scope.mainAds.length > 0) {
                if (!(($scope.mainAds.length - 1 == $scope.activeMainAdIndex && Number(val) > 0) ||
                    ($scope.activeMainAdIndex == 0 && Number(val) < 0))) {
                    $scope.activeMainAdIndex = Number($scope.activeMainAdIndex) + Number(val);
                }
                else {
                    $scope.activeMainAdIndex = 0;
                }
                updateCurrentMainAd();
            }

             $scope.carousalInterval = $interval($scope.carousalTimerFn, 5000);
        };

        // Handle carousal change
        $scope.onCarousalChange = function (index) {
            if ($scope.carousalInterval) {
                $interval.cancel($scope.carousalInterval);
            }

            $scope.activeMainAdIndex = index;
            updateCurrentMainAd();
             $scope.carousalInterval = $interval($scope.carousalTimerFn, 5000);
            $scope.carousalImgLoaded = false;
        };

        // Start carousel interval
         $scope.carousalInterval = $interval($scope.carousalTimerFn, 5000);

        // Fetch sub ads data
        function getSubAdsData() {
            homepageService.getCarousalSubAds().then(function (response) {
                if (response && response.data) {
                    $scope.ads_data = response.data;
                    if (response.data.length > 0) {
                        $scope.activeAdId = response.data[0].adId;
                    }
                    storageFactory.set("subAds", JSON.stringify(response.data), true);
                }
            });
        }

        // Fetch homepage content
        function getHomePageContent() {
            homepageService.getHomePageContent().then(function (response) {
                if (response && response.data && response.data.length > 0) {
                    var data = response.data[0];
                    $scope.carousalRightAds = data.carousalRightAds;
                    $scope.pictureAds = data.pictureAds;
                    if ($scope.pictureAds && $scope.pictureAds.length > 0) {
                        $scope.pictureAds.forEach(function (ad) {
                            ad.webpImageURL = getWebpImgUrl(ad.imageUrl);
                        });
                    }
                    $scope.topCategoryAds = data.topCategoryAds;
                    $scope.bottomCategoryAds = data.bottomCategoryAds;
                    storageFactory.set("homeAds", JSON.stringify(data), true);
                }
            });
        }

        // Fetch bottom ads
        function getBottomAds() {
            homepageService.getBottomAds().then(function (response) {
                if (response && response.data) {
                    $scope.bottomAds = response.data;
                    if ($scope.bottomAds && $scope.bottomAds.length > 0 && angular.isUndefined($scope.bottomAds[0].webpImageURL)) {
                        $scope.bottomAds.forEach(function (ad) {
                            ad.webpImageURL = getWebpImgUrl(ad.imageURL);
                        });
                    }
                    storageFactory.set("bottomAds", JSON.stringify(response.data), true);
                }
            });
        }

        // Handle ad click
        $scope.onAdClick = function (data) {
            $scope.activeAdId = data.adId;
        };

        // Helper function to get product URL
        $scope.getProductUrl = function (definitionName, vendor, name, id, cartId, lineItemId) {
            return urlService.getProductUrl(definitionName, vendor, name, id, cartId, lineItemId);
        };

        // Navigate to URL
        $scope.urlNavigate = function (url, newtab) {
            if (newtab) {
                $window.open(url, "_blank");
            } else {
                $(location).attr("href", url);
            }
        };

        // Common function to process elastic search requests
        function processElasticRequests(requests, callback) {
            var completedRequests = 0;
            var totalRequests = requests.length;
            
            requests.forEach(function (req) {
                commonService.getElasticData(configs.elasticBaseUrl, req.request)
                    .then(function(response) {
                        req.callback(response);
                        completedRequests++;
                        
                        // When all requests are complete, trigger callback
                        if (completedRequests === totalRequests && callback) {
                            callback();
                        }
                    });
            });
        }

        // Helper function to create a product request object
        function createProductRequest(type, productDef, options) {
            var config = {
                request: null,
                callback: function(response) {
                    if (response && "aggregations" in response.data) {
                        var targetProperty = options.targetProperty || 'items';
                        var aggName = options.aggName || 'new_arrivals';
                        var limit = options.limit || null;
                        
                        $scope[targetProperty] = randomService.getRandomItems(
                            response.data.aggregations[aggName].buckets[0][aggName].hits.hits,
                            limit
                        );
                    }
                }
            };
            
            // Set the appropriate request based on type
            switch (type) {
                case 'trending':
                    config.request = elasticService.buildTrendingProductsRequest();
                    break;
                case 'newArrivals':
                    config.request = elasticService.buildNewArrivalsRequest(productDef);
                    break;
                case 'freeProducts':
                    config.request = elasticService.buildFreeProductsRequest();
                    break;
                case 'productAds':
                    config.request = elasticService.buildProductAdsRequest();
                    break;
                case 'pdfArrivals':
                    config.request = elasticService.buildNewPDFArrivalsRequest(productDef);
                    break;
            }
            
            return config;
        }

        // Helper function to create a batch product request
        function createBatchProductRequest(requests) {
            return {
                request: elasticService.buildBatchProductRequest(requests),
                callback: function(response) {
                    if (response && "aggregations" in response.data) {
                        requests.forEach(function(req) {
                            var aggName = req.aggName;
                            var targetProperty = req.targetProperty;
                            var limit = req.limit || null;
                            
                            if (response.data.aggregations[aggName] && response.data.aggregations[aggName][aggName]) {
                                $scope[targetProperty] = randomService.getRandomItems(
                                    response.data.aggregations[aggName][aggName].hits.hits,
                                    limit
                                );
                            }
                        });
                    }
                }
            };
        }
        
        //#region Embrilliance Products - New Variation (New & Experienced)
        // Helper function to get product image URL
        $scope.getEmbrillianceProductImage = function(product) {
            if (!product) return '/noimage.webp';
            var prdId = (product.itemId || product.productId || '').toString();
            var productCode = prdId.indexOf('-') > -1 ? prdId.split(/-(.+)/)[1] : prdId;
            if (!product.definitionName || !product.catalog || !productCode) return '/noimage.webp';
            return urlService.getImageUrl(product.definitionName, "large", product.catalog, "", "", productCode);
        };
        
        // Helper function to get product URL (uses urlService.getProductUrl for correct path)
        $scope.getPrdUrl = function(product) {
            if (!product) return '#';
            return urlService.getProductUrl(
                product.definitionName,
                product.catalog,
                product.name,
                product.itemId || product.productId
            ) || '#';
        };
        
        $scope.embrillianceNewProducts = [];
        $scope.embrillianceStarterProducts = [];

        function getEmbrillianceTopSellers() {
            // Fetch software products for "New to Embrilliance" section
            commonService
                .getElasticData(configs.elasticBaseUrl, elasticService.buildEmbrillianceProductsRequest(12, ["Software"]))
                .then(function (response) {
                    if (response && response.data && response.data.hits && response.data.hits.hits) {
                        var allProducts = response.data.hits.hits || [];

                        // Prioritize Embrilliance Essentials by itemId if present
                        var essentialsProduct = allProducts.find(function (p) {
                            var id = (p && p._id ? p._id : (p && p._source && (p._source.itemId || p._source.productId)) || "")
                                .toString()
                                .toLowerCase();
                            return id === "btl01-atg40238";
                        });

                        var selectedProducts = [];
                        if (essentialsProduct) {
                            selectedProducts.push(essentialsProduct);
                            var otherProducts = allProducts.filter(function (p) {
                                return p && p._source && p._source.itemId !== essentialsProduct._source.itemId;
                            });
                            selectedProducts = selectedProducts.concat(otherProducts.slice(0, 1));
                        } else {
                            selectedProducts = allProducts.slice(0, 2);
                        }

                        $scope.embrillianceNewProducts = selectedProducts;
                    }
                });
        }

        function getEmbrillianceStarterPacks() {
            commonService
                .getElasticData(
                    configs.elasticBaseUrl,
                    elasticService.buildEmbrillianceStarterPacksRequest(12, ["ProjectPack", "FontPack", "DesignPack"])
                )
                .then(function (response) {
                    if (response && response.data && response.data.hits && response.data.hits.hits) {
                        var hits = response.data.hits.hits || [];
                        $scope.embrillianceStarterProducts = hits.slice(0, 2);
                    }
                });
        }
        //#endregion


        // Optimized batch fetching for initial data
        function fetchInitialElasticData() {
            var requests = [
                // This single request will handle trending products, new arrivals, and free products
                createBatchProductRequest([
                    {
                        definitionName: 'StockDesign',
                        aggName: 'trending_products',
                        priceConditions: [{ listPrice: { gt: 0 } }, { clubPrice: { gt: 0 } }],
                        sortField: 'saleRank',
                        sortOrder: 'desc',
                        includes: elasticService.includesDefault,
                        targetProperty: 'trendingProducts'
                    },
                    {
                        definitionName: 'StockDesign',
                        aggName: 'new_arrivals_stockdesign',
                        priceConditions: [{ listPrice: { gt: 0 } }, { clubPrice: { gt: 0 } }],
                        sortField: 'yearCreated',
                        sortOrder: 'desc',
                        includes: elasticService.includesDefault,
                        targetProperty: 'newArrivals'
                    },
                    {
                        definitionName: 'StockDesign',
                        aggName: 'free_products',
                        priceConditions: [{ listPrice: { lte: 0 } }],
                        sortField: 'yearCreated',
                        sortOrder: 'desc',
                        includes: elasticService.includesWithClubOnly,
                        targetProperty: 'freeProducts',
                        limit: 4
                    }
                ])
            ];

            // Process requests
            processElasticRequests(requests);
        }

        // Fetch remaining data
        function fetchRemainingElasticData() {
            var requests = [
                // Batch request for new arrivals of different product types
                createBatchProductRequest([
                    {
                        definitionName: 'Font',
                        aggName: 'new_arrivals_font',
                        priceConditions: [{ listPrice: { gt: 0 } }, { clubPrice: { gt: 0 } }],
                        sortField: 'yearCreated',
                        sortOrder: 'desc',
                        includes: elasticService.includesDefault,
                        targetProperty: 'newFonts'
                    },
                    {
                        definitionName: 'Supplies',
                        aggName: 'new_arrivals_supplies',
                        priceConditions: [{ listPrice: { gt: 0 } }, { clubPrice: { gt: 0 } }],
                        sortField: 'yearCreated',
                        sortOrder: 'desc',
                        includes: elasticService.includesDefault,
                        targetProperty: 'newSupplies'
                    },
                    {
                        definitionName: 'Fabric',
                        aggName: 'new_arrivals_fabric',
                        priceConditions: [{ listPrice: { gt: 0 } }, { clubPrice: { gt: 0 } }],
                        sortField: 'yearCreated',
                        sortOrder: 'desc',
                        includes: elasticService.includesDefault,
                        targetProperty: 'newFabrics'
                    },
                    {
                        definitionName: 'Machine',
                        aggName: 'new_arrivals_machine',
                        priceConditions: [{ listPrice: { gt: 0 } }, { clubPrice: { gt: 0 } }],
                        sortField: 'yearCreated',
                        sortOrder: 'desc',
                        includes: elasticService.includesDefault,
                        targetProperty: 'newMachines'
                    },
                    {
                        definitionName: 'DesignPack',
                        aggName: 'new_arrivals_designpack',
                        priceConditions: [{ listPrice: { gt: 0 } }, { clubPrice: { gt: 0 } }],
                        sortField: 'yearCreated',
                        sortOrder: 'desc',
                        includes: elasticService.includesDefault,
                        targetProperty: 'newPacks'
                    }
                ]),
                
                // Batch request for PDF patterns
                createBatchProductRequest([
                    {
                        definitionName: 'Sewing PDF Patterns',
                        aggName: 'pdf_arrivals_sewing_pdf_patterns',
                        priceConditions: [{ listPrice: { gt: 0 } }],
                        sortField: 'yearCreated',
                        sortOrder: 'desc',
                        includes: elasticService.includesDefault,
                        targetProperty: 'sewingPDFPatterns'
                    },
                    {
                        definitionName: 'Clothing PDF Patterns',
                        aggName: 'pdf_arrivals_clothing_pdf_patterns',
                        priceConditions: [{ listPrice: { gt: 0 } }],
                        sortField: 'yearCreated',
                        sortOrder: 'desc',
                        includes: elasticService.includesDefault,
                        targetProperty: 'clothingPDFPatterns'
                    }
                ]),
                
                // Product ads
                createProductRequest('productAds', null, {
                    targetProperty: 'productAds_data',
                    aggName: 'softwares',
                    limit: 2
                })
            ];

            // Process requests
            processElasticRequests(requests, function() {
                $scope.getCommunityArticles();
            });
        }

        // Set up scroll listener to load remaining data
        function setupScrollListener() {
            var hasFetched = false;
            var lastScrollTime = 0;
            var throttleDelay = 100; // ms
            var idleTimeout = 3000; // ms
            var idleTimer = null;
        
            function shouldFetchData() {
                var scrollTop = $window.pageYOffset || document.documentElement.scrollTop;
                var windowHeight = $window.innerHeight || document.documentElement.clientHeight;
        
                // If user has scrolled at least 100px more than the viewport height
                return (scrollTop + windowHeight) >= (windowHeight + 100);
            }
        
            function triggerFetchIfNeeded() {
                if (hasFetched) return;
                if (shouldFetchData()) {
                    hasFetched = true;
                    removeListeners();
                    fetchRemainingElasticData();
                }
            }
        
            function throttledScrollHandler() {
                var now = Date.now();
                if (now - lastScrollTime < throttleDelay) return;
                lastScrollTime = now;
                triggerFetchIfNeeded();
            }
        
            function startIdleTimer() {
                clearTimeout(idleTimer);
                idleTimer = setTimeout(function() {
                    triggerFetchIfNeeded();
                }, idleTimeout);
            }
        
            function removeListeners() {
                angular.element($window).off('scroll', throttledScrollHandler);
                angular.element($window).off('resize', throttledScrollHandler);
                clearTimeout(idleTimer);
            }
        
            // Attach listeners
            angular.element($window).on('scroll', throttledScrollHandler);
            angular.element($window).on('resize', throttledScrollHandler);
        
            // Cleanup on scope destroy
            $scope.$on('$destroy', function() {
                removeListeners();
            });
        
            // Initial check using requestAnimationFrame
            requestAnimationFrame(function() {
                triggerFetchIfNeeded();
                startIdleTimer();
            });
        }

        // Fetch community articles
        $scope.getCommunityArticles = function () {
            homepageService.getCommunityArticles().then(function (response) {
                if (response && response.data) {
                    $scope.articles_data = response.data;
                }
            });
        };

        // Fetch digital events
        $scope.getDigitalEvents = function () {
            $scope.eventBannerimgPath = window.__env.digitalEventImgBaseUrl;
            var count = 2;
            homepageService.getDigitalEvents(count).then(function (response) {
                if (response && response.data) {
                    $scope.showEvents = "true";
                    $scope.events = response.data.map(function (event) {
                        return digitalEventFormatterService.enrichEvent(event);
                    });
                }
            });
        };

        // Fetch page content
        $scope.getPageContent = function () {
            membershipService.getPageContent().then(function (response) {
                if (response && response.data) {
                    $scope.bannerContent = response.data.landingPage.banner;
                    $scope.membershipBenefits = response.data.landingPage.benefits;
                }
            });
        };

        // Initialize the controller
        $scope.initialize = function () {
            $scope.getAdsData();
            fetchInitialElasticData();
            getEmbrillianceTopSellers();
            getEmbrillianceStarterPacks();
            // Then get remaining page content
            $scope.getPageContent();
            $scope.getDigitalEvents();
            setupScrollListener();
        };
    }
]);
